import React from "react";
import { Row, Col } from "reactstrap";

import RegisterBusinessForm from "../../components/registerBusiness/RegisterBusinessForm";

export default function RegisterBusiness() {
  return (
    <div>
      <Row>
        <Col sm={12}>
          <RegisterBusinessForm />
        </Col>
      </Row>
    </div>
  );
}